import isEqual from 'lodash/isEqual';

import { FILES_SUGGESTIONS, setCustomAccountSetting } from 'utils/baseAccountSettings';

import { SharedUserSettingsEnum, useSettingsStore } from '../store';

interface LibrarySettingConfig {
  settingKey: SharedUserSettingsEnum;
  defaultValue: boolean;
}

const LIBRARY_SETTINGS: LibrarySettingConfig[] = [
  {
    settingKey: SharedUserSettingsEnum.LIBRARY_IMPORT_SUGGEST_FILES,
    defaultValue: true
  }
];

export function subscribe() {
  // remote settings store change, set local library setting
  const settingsSubscription = useSettingsStore.subscribe((state, prevState) => {
    LIBRARY_SETTINGS.forEach(({ settingKey, defaultValue }) => {
      const currentValue = state.userSettings.settings[settingKey] ?? defaultValue;
      const prevValue = prevState.userSettings.settings[settingKey] ?? defaultValue;

      if (!isEqual(currentValue, prevValue)) {
        if (settingKey === SharedUserSettingsEnum.LIBRARY_IMPORT_SUGGEST_FILES) {
          setCustomAccountSetting(FILES_SUGGESTIONS, currentValue ? 'true' : 'false');
        }
      }
    });
  });

  // cleanup
  return () => {
    settingsSubscription();
  };
}
